'use client';

import { useAtomValue, useSetAtom } from 'jotai';

import { filtersListAtom } from '@core/Atoms/Plp/FiltersListAtom';
import { DEFAULT_SORTING, SORT_KEY, SORT_OPTIONS_UK } from '@core/Constants/Sort';
import type { Locale } from '@core/Entities/Locale/Locale.entity';
import { getFilterFromArray } from '@core/Utils/SearchFilters/GetFilterFromArray';
import { Sort } from '@gds/Icons/Paths/Sort';
import { sortDrawerOpenAtom } from '@plp/Atoms/SortDrawerOpenAtom';

import type { SortMessages } from '../Filters/Components/Sort/Sort.messages';

import styles from './QuickFilters.module.css';

export const QuickFiltersSort = ({
  locale,
  sortMessages,
}: {
  locale: Locale;
  sortMessages: SortMessages;
}) => {
  const openSortDrawer = useSetAtom(sortDrawerOpenAtom);
  const filtersList = useAtomValue(filtersListAtom);

  const sortFilter = getFilterFromArray(SORT_KEY, filtersList);

  const sortOptions = SORT_OPTIONS_UK.map(option => ({
    label: sortMessages[option as keyof SortMessages],
    value: option,
  }));

  const selectedSortValue = sortFilter
    ? sortOptions.find(option => option.value === sortFilter?.value)
    : sortOptions.find(option => option.value === DEFAULT_SORTING[locale]);

  return (
    <div className={styles.sort}>
      <button className="typography-subheading-3" onClick={() => openSortDrawer(true)}>
        {selectedSortValue?.label}
        <Sort />
      </button>
    </div>
  );
};
